import iconMapping from './iconMapping';

export const getIconFromName = (iconName: string, iconType: string = 'carbon') => {
  if (!iconName || iconName?.trim()?.length === 0) return;

  if (iconType === 'carbon') {
    return iconMapping[iconName];
  }
  return null;
};
